import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { TherapistAction } from '../../actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  GET_APPOINTMENT_SLOTS_REQUEST,
  GET_APPOINTMENT_SLOTS_SUCCESS,
  GET_APPOINTMENT_SLOTS_FAILURE,
} = TherapistAction;

function* getAppointmentSlots(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      therapistSchedulingServices.getAppointmentSlots,
      action.payload
    );
    if (response?.status === 200) {
      yield put({ type: GET_APPOINTMENT_SLOTS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_APPOINTMENT_SLOTS_FAILURE, payload: error });
  }
}

function* getAppointmentSlotsSaga() {
  yield takeEvery(GET_APPOINTMENT_SLOTS_REQUEST, getAppointmentSlots);
}

export default getAppointmentSlotsSaga;

